export default __webpack_public_path__ + "static/media/icon-playlist.09df5fe7.svg";